// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--Js6DfA_fkDNVJphw","icon":"icon--hhFVTrMdJzEfBHDh"};